var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHcareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.227 49.0169C15.7605 46.6455 14.9883 43.9105 14.9978 41.1221L14.998 19.38L35.9976 12.375L56.9971 19.3726V41.1221C57.0065 43.9105 56.2343 46.6455 54.7679 49.0169C53.3021 51.3883 51.2006 53.3015 48.702 54.5392L35.9974 60.8918L23.2929 54.5392C20.7943 53.3015 18.6928 51.3883 17.227 49.0169ZM35.9974 18.6974L20.9978 23.6998L20.9978 41.1221C20.9921 42.7942 21.4546 44.4348 22.3335 45.8567C23.2123 47.2791 24.472 48.4269 25.9703 49.1697L35.9975 54.1873L46.0246 49.1697C47.5229 48.4268 48.7826 47.2791 49.6615 45.8567C50.5404 44.4347 51.0029 42.7941 50.9971 41.1221V23.6998L35.9974 18.6974ZM38.9973 46.2958H32.9978V39.5457H26.2477V33.5462H32.9978V26.7961H38.9973V33.5462H45.7474V39.5457H38.9973V46.2958Z",
    fill: "url(#paint0_linear_8677_44525)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8677_44525",
    x1: 35.9974,
    y1: 2.67163,
    x2: 35.9974,
    y2: 60.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcareIcon);
export default __webpack_public_path__ + "static/media/hcare_icon.2410d1ac174909eb87be0f33584d4c82.svg";
export { ForwardRef as ReactComponent };